// extracted by mini-css-extract-plugin
export default {"contentWrapper":"PagePlaceholder_contentWrapper__1TLAQ","pageWrapper":"PagePlaceholder_pageWrapper__uOsLQ","contentHeader":"PagePlaceholder_contentHeader__P0WHi"};